import { DateObject, useSettings } from '@capsicum/common';

import { type ApprovedFooterPage } from '../models';

export const useShowApprovedFooter = (isGatewayPage?: boolean) => {
	const {
		areSettingsLoading,
		settings: { ukApprovedByFooter }
	} = useSettings(isGatewayPage);

	const shouldShowApprovedFooter = (page: ApprovedFooterPage) => ukApprovedByFooter[page]?.visible;

	const approvedFooterDate = (page: ApprovedFooterPage) => {
		const date = ukApprovedByFooter[page]?.date;

		if (date) {
			const [day, month, year] = date.split('/');
			const approvalDate = new DateObject(`${year}-${month}-${day}`).format('L');

			return approvalDate;
		} else {
			return 'Invalid Date';
		}
	};

	return {
		approvedFooterDate,
		areSettingsLoading,
		shouldShowApprovedFooter
	};
};
